<template>
  <div class="CompanyProfile">
    <div class="cont">
      <ComTitlte titleEn="INTRODUCTION" titleZh="公司简介"></ComTitlte>
      <div class="main clear">
        <div class="m_img">
          <img src="../../assets/img/company/a_img.png" alt="..." />
        </div>
        <div class="m_info">
          <div class="i_title">
            <i class="t_icon"></i>
            <span class="t_zh">公司介绍</span>
            <span class="t_en">INTROUDUCTION</span>
          </div>
          <div class="m_desc">
            <p>
              广州统计师事务所于1998年8月成立，与原广州市统计咨询中心（广州市统计局下属公益三类事业单位）是“一套人马两块牌子”合署办公，原属广州市统计局监管，现属广州工业投资控股集团有限公司，受广州市人民政府国有资产监督管理委员会监管。
            </p>
            <p>
              广州统计师事务所是一家对外开展统计调查和提供信息咨询服务的国有企业，作为具备本地化服务能力和拥有良好商业信誉及丰富业务经验的专业机构，始终坚持利用统计数据和网络资源，为社会各界提供精准统计调查服务，其中部分调研成果受到市委市政府及相关职能部门的肯定。
            </p>
          </div>
          <div class="i_title">
            <i class="t_icon"></i>
            <span class="t_zh">服务宗旨</span>
            <span class="t_en">PURPOSE</span>
          </div>
          <div class="m_purpose">
            <ul class="purpose_list">
              <li class="purpose_item">
                <i class="p_icon p_icon1"></i>
                <span class="purpose_lable">客观</span>
              </li>
              <li class="purpose_item">
                <i class="p_icon p_icon2"></i>
                <span class="purpose_lable">真实</span>
              </li>
              <li class="purpose_item">
                <i class="p_icon p_icon3"></i>
                <span class="purpose_lable">专业</span>
              </li>
            </ul>
          </div>
          <div class="p_text">
            致力于为政府机关、研究机构及各类企事业单位，提供社情民意调查、专项统计、课题研究、统计数据咨询等服务。
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ComTitlte from "@/components/common/comTitle";
export default {
  name: "CompanyProfile",
  components: { ComTitlte },
};
</script>

<style lang="scss" scoped>
$themeColor: #406cdd;
$themeMinWidth: 1180px;
.CompanyProfile {
  position: relative;
  z-index: 9;
}
.cont {
  width: $themeMinWidth;
  margin: 0 auto;
  .main {
    padding: 20px 0 0 0;
    position: relative;
    .m_img {
      width: 476px;
      height: 400px;
      position: absolute;
      top: 78px;
      left: 0;
      z-index: 2;
      img {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    .m_info {
      float: right;
      width: 802px;
      height: 507px;
      background-color: #ffffff;
      box-shadow: 2px 3px 21px 0px rgba(22, 22, 22, 0.05);
      box-sizing: border-box;
      padding: 30px 30px 0 154px;
      .i_title {
        display: flex;
        align-items: center;
        .t_icon {
          width: 13px;
          height: 16px;
          background: url("../../assets/img/company/a_icon1.png") center
            no-repeat;
          background-size: 100% 100%;
        }
        .t_zh {
          font-size: 18px;
          line-height: 30px;
          color: #333;
          margin-left: 8px;
        }
        .t_en {
          font-size: 18px;
          line-height: 30px;
          color: #bcbcbc;
          margin-left: 6px;
        }
      }
      .m_desc {
        padding: 20px 0;
        p {
          font-size: 16px;
          text-indent: 32px;
          line-height: 30px;
          text-align: justify;
          color: #666;
        }
      }
    }
    .m_purpose {
      .purpose_list {
        display: flex;
        justify-content: space-between;
        position: relative;
        .purpose_item {
          display: flex;
          align-items: center;
          justify-content: center;
          height: 86px;
          width: 190px;
          .p_icon {
            display: inline-block;
            width: 34px;
            height: 34px;

            &.p_icon1 {
              background: url("../../assets/img/company/a_icon2.png") center
                no-repeat;
              background-size: cover;
            }
            &.p_icon2 {
              background: url("../../assets/img/company/a_icon3.png") center
                no-repeat;
              background-size: cover;
            }
            &.p_icon3 {
              background: url("../../assets/img/company/a_icon4.png") center
                no-repeat;
              background-size: cover;
            }
          }
          .purpose_lable {
            font-size: 16px;
            font-weight: bold;
            line-height: 30px;
            color: #666666;
            margin-left: 6px;
          }
        }
      }
    }
    .p_text {
      font-size: 16px;
      text-indent: 32px;
      line-height: 30px;
      text-align: justify;
    }
  }
}
</style>
